import React, { Component } from 'react';
import { connect } from 'react-redux';

import { 
	ddnyTitle,
	ddnyThumbnailSrc, 
} from '../../../../utils/ddny';

import styles from './_styles/RelatedItemThumbnail.module.scss';

import * as ddnyActionCreators from '../../../../actions/ddny';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class RelatedItemThumbnail extends Component {

	constructor(props) {
	
		super(props);
	
		this.state = {
			
		};
	}

	handleClick() {
		if(this.props.onClick) {
			this.props.onClick(this.props.item);
		}
	}
	
	render() {
		return <div className={`${styles.RelatedItemThumbnail}`} onClick={this.handleClick.bind(this)}>
			
			<div className={styles.itemWrapper}>
				<div className={styles.mediaWrapper}>
					<div className={styles.mediaElement}>
						<div className={styles.imgFrame}>
							<img src={ddnyThumbnailSrc(this.props.item?.related_product)} />
						</div>
					</div>
				</div>
				<div className={styles.titleWrapper}>
					<div className={styles.title}>{ddnyTitle(this.props.item?.related_product)}</div>
				</div>
				<div className={styles.labelWrapper}>
					{this.props.item?.label}
				</div>
			</div>
			
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(RelatedItemThumbnail);